module.exports = __webpack_public_path__ + "img/DVR.0fa8a90b.png";